module.exports = __webpack_public_path__ + "static/media/Add-start-date.5e227506.png";